module.exports = __webpack_public_path__ + "img/step-img2.18cc8b1c.png";